// extracted by mini-css-extract-plugin
module.exports = {"loop__list":"c8_sg","loop__listInner":"c8_sh","loop__part":"c8_sj","loop__entryShort":"c8_sk","loop__entryLeft":"c8_sl","loop__entryRight":"c8_sm","loop__pagination":"c8_sn"};